(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["amezoni-bulk-active"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (scope) => {
      scope.querySelectorAll('[data-bulk-active]').forEach((root) => {
        if (root.dataset.initialized) return;
        root.dataset.initialized = 'true';
        let config;
        try { config = JSON.parse(root.dataset.config); } catch { return; }
        const validInteger = (value) => Number.isSafeInteger(value) && value > 0;
        const validPrice = (value) => typeof value === 'number' && value > 0 && Number.isSafeInteger(Math.round(value * 100)) && Math.abs(value * 100 - Math.round(value * 100)) < 0.000001;
        const validTiers = Array.isArray(config.tiers) && (config.tiers.length === 2 || config.tiers.length === 3) && config.tiers.every((tier, index, tiers) => {
          if (!tier || !validInteger(tier.quantity) || !validPrice(tier.price)) return false;
          if (index === 0) return tier.quantity === 1;
          const previous = tiers[index - 1];
          return tier.quantity > previous.quantity && tier.price <= previous.price && Math.round(tier.price * 100) * tier.quantity >= Math.round(previous.price * 100) * (tier.quantity - 1);
        });
        const strings = config.strings;
        const matchingCurrency = config.currency === config.presentmentCurrency;
        if (config.status !== 'active' || !config.exclusiveBase || !/^\d+$/.test(config.variantId || '') || !validInteger(Number(config.variantId)) || !['kg', 'lot'].includes(config.unit) || !validInteger(config.packSize) || !Number.isSafeInteger(config.stock) || config.stock < 0 || !config.tracked || config.policy !== 'deny' || config.minimum !== 1 || config.increment !== 1 || config.maximum != null && !validInteger(config.maximum) || !validInteger(config.basePrice) || !strings || typeof strings !== 'object' || !/^[A-Z]{3}$/.test(config.currency || '') || !/^[A-Z]{3}$/.test(config.presentmentCurrency || '') || !validTiers || config.unit === 'kg' && (config.packSize !== 1 || config.baseWeight !== 1000)) return;
        if (matchingCurrency && Math.round(config.tiers[0].price * 100) !== config.basePrice || !Number.isSafeInteger(config.stock * config.packSize) || !Number.isSafeInteger(config.stock * config.basePrice)) return;
        const stockCap = config.available ? Math.min(config.stock, config.maximum == null ? config.stock : config.maximum) : 0;
        const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: config.presentmentCurrency, currencyDisplay: 'code' });
        const number = new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 2 });
        const format = (key, values = {}) => String(strings[key] || '').replace(/\[([a-zA-Z]+)\]/g, (_, name) => String(values[name] ?? ''));
        const unitLabel = (quantity) => config.unit === 'kg' ? strings.kg : quantity === 1 ? strings.lot : strings.lots;
        const priceLabel = (cents) => format('unitPrice', { price: money.format(cents / 100), unit: config.unit === 'kg' ? strings.kg : strings.lot });
        const get = (name) => root.querySelector('[data-bulk-' + name + ']');
        const form = root.querySelector('form');
        const input = get('quantity');
        const add = get('add');
        let inCart = 0;
        let cartReady = false;
        let busy = false;
        let locked = false;
        let cartVersion = 0;
        const remaining = () => Math.max(0, stockCap - inCart);
        const validQuantity = () => input.value.trim() !== '' && validInteger(Number(input.value)) && Number(input.value) <= remaining();
        get('pack').textContent = config.unit === 'kg' ? strings.kgPack : format('lotPack', { pack: number.format(config.packSize) });
        get('label').textContent = config.unit === 'kg' ? strings.quantityKg : strings.quantityLot;
        get('table').hidden = !matchingCurrency;
        get('currency').hidden = matchingCurrency;
        get('estimate').hidden = !matchingCurrency;
        const rows = matchingCurrency ? config.tiers.map((tier) => {
          const row = document.createElement('tr');
          const quantity = document.createElement('td');
          const price = document.createElement('td');
          quantity.textContent = format('tierQuantity', { count: number.format(tier.quantity), unit: unitLabel(tier.quantity) });
          price.textContent = priceLabel(Math.round(tier.price * 100));
          row.append(quantity, price);
          get('tiers').append(row);
          return row;
        }) : [];
        const render = () => {
          const max = remaining();
          const quantity = Number(input.value);
          const valid = validQuantity();
          const enabled = cartReady && !busy && !locked && max > 0;
          input.max = String(max);
          input.disabled = !cartReady || locked || max === 0;
          input.readOnly = busy;
          root.querySelector('[name="id"]').disabled = !cartReady || locked || max === 0;
          get('minus').disabled = !enabled || !valid || quantity <= 1;
          get('plus').disabled = !enabled || !valid || quantity >= max;
          add.disabled = !enabled || !valid;
          add.textContent = busy ? strings.adding : stockCap === 0 ? strings.soldOut : strings.addToCart;
          form.setAttribute('aria-busy', String(busy));
          get('stock').textContent = format('stock', { count: number.format(max), unit: unitLabel(max) });
          get('in-cart').hidden = inCart === 0;
          get('in-cart').textContent = format('inCart', { count: number.format(inCart), unit: unitLabel(inCart) });
          get('error').hidden = !cartReady || valid;
          get('error').textContent = valid ? '' : max === 0 ? stockCap === 0 ? strings.soldOut : strings.atCap : format('invalidQuantity', { max: number.format(max) });
          input.setAttribute('aria-invalid', String(!valid));
          get('quick').querySelectorAll('button').forEach((button) => {
            button.disabled = !enabled || Number(button.dataset.quantity) > max;
            button.setAttribute('aria-pressed', String(valid && Number(button.dataset.quantity) === quantity));
          });
          rows.forEach((row) => { row.classList.remove('is-active'); row.removeAttribute('aria-current'); });
          get('summary').textContent = '';
          get('rate').textContent = '';
          get('total').textContent = '—';
          get('saving').hidden = true;
          if (!valid || !cartReady) return;
          get('summary').textContent = config.unit === 'kg' ? format('kgSummary', { quantity: number.format(quantity), pounds: number.format(quantity * 2.2046226218) }) : format('lotSummary', { quantity: number.format(quantity), unit: unitLabel(quantity), pieces: number.format(quantity * config.packSize) });
          if (!matchingCurrency) return;
          let tierIndex = 0;
          config.tiers.forEach((tier, index) => { if (quantity + inCart >= tier.quantity) tierIndex = index; });
          const cents = Math.round(config.tiers[tierIndex].price * 100);
          rows[tierIndex].classList.add('is-active');
          rows[tierIndex].setAttribute('aria-current', 'true');
          get('rate').textContent = priceLabel(cents);
          get('total').textContent = money.format(cents * quantity / 100);
          const savings = (config.basePrice - cents) * quantity;
          get('saving').hidden = savings === 0;
          get('saving').textContent = savings > 0 ? format('saving', { saving: money.format(savings / 100) }) : '';
        };
        const acceptCart = (cart) => {
          if (!cart || cart.currency !== config.presentmentCurrency || !Array.isArray(cart.items)) return false;
          const lines = cart.items.filter((item) => String(item.variant_id) === config.variantId);
          if (lines.some((item) => !validInteger(item.quantity) || !Number.isSafeInteger(item.final_line_price) || item.final_line_price < 0)) return false;
          const quantity = lines.reduce((sum, item) => sum + item.quantity, 0);
          const total = lines.reduce((sum, item) => sum + item.final_line_price, 0);
          if (!Number.isSafeInteger(quantity) || !Number.isSafeInteger(total)) return false;
          inCart = quantity;
          cartReady = true;
          cartVersion += 1;
          get('cart-total').hidden = quantity === 0;
          get('cart-total').textContent = format('cartTotal', { total: money.format(total / 100) });
          get('cart-link').hidden = quantity === 0 && !locked;
          render();
          return true;
        };
        config.tiers.forEach((tier) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.quantity = String(tier.quantity);
          button.textContent = format('choice', { count: number.format(tier.quantity), unit: unitLabel(tier.quantity) });
          button.addEventListener('click', () => { input.value = String(tier.quantity); render(); });
          get('quick').append(button);
        });
        input.addEventListener('input', render);
        input.addEventListener('change', render);
        get('minus').addEventListener('click', () => { input.value = String(Number(input.value) - 1); render(); });
        get('plus').addEventListener('click', () => { input.value = String(Number(input.value) + 1); render(); });
        form.addEventListener('submit', (event) => {
          if (!cartReady || busy || locked || !validQuantity()) { event.preventDefault(); event.stopImmediatePropagation(); render(); }
        });
        form.addEventListener('amezoni:bulk-add-start', () => { busy = true; get('message').textContent = strings.adding; render(); });
        form.addEventListener('amezoni:bulk-validate', (event) => {
          const accepted = acceptCart(event.detail && event.detail.cart);
          if (!accepted) { cartReady = false; get('message').textContent = strings.cartError; }
          if (!accepted || locked || !validQuantity()) { event.preventDefault(); render(); }
        });
        form.addEventListener('amezoni:bulk-add-complete', (event) => {
          busy = false;
          if (!acceptCart(event.detail && event.detail.cart)) {
            locked = true;
            get('message').textContent = strings.confirmationError;
          } else {
            input.value = '1';
            get('message').textContent = strings.added;
          }
          get('cart-link').hidden = false;
          render();
        });
        form.addEventListener('amezoni:bulk-add-error', (event) => {
          busy = false;
          const kind = event.detail && event.detail.kind;
          if (kind === 'confirmation') locked = true;
          if (kind !== 'validation') get('message').textContent = kind === 'confirmation' ? strings.confirmationError : kind === 'preflight' ? strings.cartError : event.detail && event.detail.message || strings.addError;
          get('cart-link').hidden = false;
          render();
        });
        document.addEventListener('amezoni:cart', (event) => {
          if (!root.isConnected) return;
          if (!acceptCart(event.detail && event.detail.cart)) { cartReady = false; get('message').textContent = strings.cartError; render(); }
        });
        get('pending').hidden = true;
        get('content').hidden = false;
        render();
        const initialVersion = cartVersion;
        fetch(config.cartUrl + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then((response) => { if (!response.ok) throw new Error(); return response.json(); })
          .then((cart) => { if (initialVersion !== cartVersion) return; if (!acceptCart(cart)) throw new Error(); get('message').textContent = ''; })
          .catch(() => { if (initialVersion !== cartVersion) return; cartReady = false; get('message').textContent = strings.cartError; get('cart-link').hidden = false; render(); });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    else init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["amezoni-bulk-staged"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (scope) => {
      scope.querySelectorAll('[data-bulk-staged]').forEach((root) => {
        if (root.dataset.initialized) return;
        root.dataset.initialized = 'true';
        const pending = root.querySelector('[data-bulk-pending]');
        let config;
        try { config = JSON.parse(root.dataset.config); } catch { return; }
        const strings = config.strings;
        if (!strings || typeof strings !== 'object') return;
        if (config.currency !== config.presentmentCurrency) {
          pending.textContent = strings.currencyPending;
          return;
        }
        const validInteger = (value) => Number.isSafeInteger(value) && value > 0;
        const validPrice = (value) => typeof value === 'number' && Number.isFinite(value) && value > 0 && Number.isSafeInteger(Math.round(value * 100)) && Math.abs(value * 100 - Math.round(value * 100)) < 0.000001;
        const validTiers = Array.isArray(config.tiers) && (config.tiers.length === 2 || config.tiers.length === 3) && config.tiers.every((tier, index, tiers) => {
          if (!tier || !validInteger(tier.quantity) || !validPrice(tier.price)) return false;
          if (index === 0) return tier.quantity === 1;
          const previous = tiers[index - 1];
          return tier.quantity > previous.quantity && tier.price <= previous.price && Math.round(tier.price * 100) * tier.quantity >= Math.round(previous.price * 100) * (tier.quantity - 1);
        });
        if (config.status !== 'staged' || !config.baseExists || !['kg', 'lot'].includes(config.unit) || !validInteger(config.packSize) || !validInteger(config.stock) || !/^[A-Z]{3}$/.test(config.currency || '') || !validTiers || config.unit === 'kg' && (config.packSize !== 1 || config.baseWeight !== 1000)) return;
        if (!Number.isSafeInteger(config.stock * config.packSize) || !Number.isSafeInteger(Math.round(config.tiers[0].price * 100) * config.stock)) return;
        let money;
        try { money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: config.currency, currencyDisplay: 'code' }); } catch { return; }
        const number = new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 2 });
        const format = (key, values = {}) => String(strings[key] || '').replace(/\[([a-zA-Z]+)\]/g, (_, name) => String(values[name] ?? ''));
        const unitLabel = (quantity) => config.unit === 'kg' ? strings.kg : quantity === 1 ? strings.lot : strings.lots;
        const priceLabel = (cents) => format('unitPrice', { price: money.format(cents / 100), unit: config.unit === 'kg' ? strings.kg : strings.lot });
        const input = root.querySelector('[data-bulk-quantity]');
        const minus = root.querySelector('[data-bulk-minus]');
        const plus = root.querySelector('[data-bulk-plus]');
        const error = root.querySelector('[data-bulk-error]');
        const summary = root.querySelector('[data-bulk-summary]');
        const rate = root.querySelector('[data-bulk-rate]');
        const total = root.querySelector('[data-bulk-total]');
        const saving = root.querySelector('[data-bulk-saving]');
        const tiers = root.querySelector('[data-bulk-tiers]');
        const quick = root.querySelector('[data-bulk-quick]');
        root.querySelector('[data-bulk-pack]').textContent = config.unit === 'kg' ? strings.kgPack : format('lotPack', { pack: number.format(config.packSize) });
        root.querySelector('[data-bulk-stock]').textContent = format('stock', { count: number.format(config.stock), unit: unitLabel(config.stock) });
        root.querySelector('[data-bulk-label]').textContent = config.unit === 'kg' ? strings.quantityKg : strings.quantityLot;
        const rows = config.tiers.map((tier) => {
          const row = document.createElement('tr');
          const quantity = document.createElement('td');
          const price = document.createElement('td');
          quantity.textContent = format('tierQuantity', { count: number.format(tier.quantity), unit: unitLabel(tier.quantity) });
          price.textContent = priceLabel(Math.round(tier.price * 100));
          row.append(quantity, price);
          tiers.append(row);
          return row;
        });
        const render = () => {
          const raw = input.value;
          const quantity = Number(raw);
          const valid = raw.trim() !== '' && validInteger(quantity) && quantity <= config.stock;
          error.hidden = valid;
          error.textContent = valid ? '' : format('invalidQuantity', { max: number.format(config.stock) });
          input.setAttribute('aria-invalid', String(!valid));
          minus.disabled = !valid || quantity <= 1;
          plus.disabled = !valid || quantity >= config.stock;
          quick.querySelectorAll('button').forEach((button) => button.setAttribute('aria-pressed', String(valid && Number(button.dataset.quantity) === quantity)));
          if (!valid) {
            summary.textContent = '';
            rate.textContent = '';
            total.textContent = '—';
            saving.hidden = true;
            saving.textContent = '';
            rows.forEach((row) => { row.classList.remove('is-active'); row.removeAttribute('aria-current'); });
            return;
          }
          let tierIndex = 0;
          config.tiers.forEach((tier, index) => { if (quantity >= tier.quantity) tierIndex = index; });
          const cents = Math.round(config.tiers[tierIndex].price * 100);
          rows.forEach((row, index) => { row.classList.toggle('is-active', index === tierIndex); if (index === tierIndex) row.setAttribute('aria-current', 'true'); else row.removeAttribute('aria-current'); });
          summary.textContent = config.unit === 'kg' ? format('kgSummary', { quantity: number.format(quantity), pounds: number.format(quantity * 2.2046226218) }) : format('lotSummary', { quantity: number.format(quantity), unit: unitLabel(quantity), pieces: number.format(quantity * config.packSize) });
          rate.textContent = priceLabel(cents);
          total.textContent = money.format(cents * quantity / 100);
          const savings = (Math.round(config.tiers[0].price * 100) - cents) * quantity;
          saving.hidden = savings === 0;
          saving.textContent = savings > 0 ? format('saving', { saving: money.format(savings / 100) }) : '';
        };
        config.tiers.forEach((tier) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.quantity = String(tier.quantity);
          button.textContent = format('choice', { count: number.format(tier.quantity), unit: unitLabel(tier.quantity) });
          button.disabled = tier.quantity > config.stock;
          button.addEventListener('click', () => { input.value = String(tier.quantity); render(); });
          quick.append(button);
        });
        input.max = String(config.stock);
        input.disabled = false;
        input.addEventListener('input', render);
        input.addEventListener('change', render);
        input.addEventListener('keydown', (event) => { if (event.key === 'Enter') event.preventDefault(); });
        minus.addEventListener('click', () => { input.value = String(Number(input.value) - 1); render(); });
        plus.addEventListener('click', () => { input.value = String(Number(input.value) + 1); render(); });
        pending.hidden = true;
        root.querySelector('[data-bulk-content]').hidden = false;
        render();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    else init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
